export default "__VITE_ASSET__NzY82_pN__"